module.exports = __webpack_public_path__ + "static/template-home-hero-background-f3b32be893ba48a462df802dbceb1f09.jpg";